(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template-debut"]) return;
  try {
    
	/* kick the review app to redraw if in customizer */

$(window).on('shopify:section:load', function () {
	if( $('#shopify-product-reviews').length > 0 ) {
		
                return SPR.registerCallbacks(),
                SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges();
	}

});


  } catch(e) { console.error(e); }
})();
})();
